interface ResponseItem {
    validUntil: string | null;
    amount: number;
    feeDescription: string;
    feeCode: string;
}

interface TransformedSubFeesItem {
    key: number;
    children: any[];
    data: {
        validUntil: string | null;
        amount: number;
        feeDescription: string;
        feeCode: string;
    };
}

export const transformSubFees = (response: ResponseItem[]): TransformedSubFeesItem[] => {
    return response.map((subFeeItem, index) => ({
        key: index + 1,
        children: [],
        data: {
            validUntil: subFeeItem.validUntil,
            amount: subFeeItem.amount,
            feeDescription: subFeeItem.feeDescription,
            feeCode: subFeeItem.feeCode,
        },
    }));
};

interface ResponseItem {
    feeSubCodeDescription: string;
    validUntil: string;
}

interface TransformedItem {
    key: number;
    children: any[];
    data: {
        feeDescription: string;
        validUntil: string;
    };
}

export const transformDescriptionHistory = (response: ResponseItem[]): TransformedItem[] => {
    return response.map((item, index) => ({
        key: index + 1,
        children: [],
        data: {
            feeDescription: item.feeSubCodeDescription,
            validUntil: item.validUntil,
        },
    }));
};

interface HistoryItem {
    validFrom: string | null;
    amount: number;
    feeDescription: string;
}

interface ResponseItem {
    feeSubCodeDescription: string;
    history: HistoryItem[];
}

interface TransformedHistoryItem {
    key: number;
    children: any[];
    data: {
        validFrom: string | null;
        amount: number;
        feeDescription: string;
    };
}

interface TransformedResponseItem {
    feeSubCodeDescription: string;
    history: TransformedHistoryItem[];
}

export const transformAmountHistory = (response: ResponseItem[]): TransformedResponseItem[] => {
    return response.map((item) => ({
        feeSubCodeDescription: item.feeSubCodeDescription,
        history: item.history.map((historyItem, index) => ({
            key: index + 1,
            children: [],
            data: {
                validFrom: historyItem.validFrom,
                amount: historyItem.amount,
                feeDescription: historyItem.feeDescription,
            },
        })),
    }));
};